import React, { type FC, type PropsWithChildren } from 'react';

import reactHTMLParser from '../../utils/reactHTMLParser';
import Box from '../box/box';
import type { Lucid } from '../../types/types';

type TechblogHtmlBlockProps = {
  item: Lucid.Directus.Generated.Tech_Blog_Html;
};

const TechblogHtmlBlock: FC<PropsWithChildren<TechblogHtmlBlockProps>> = ({ item }) => (
  <Box
    key={item.id}
    css={theme => [
      { label: 'techblogHtmlBlock' },
      theme.shared.blogStyles(theme),
      theme.shared.htmlParserStyles(theme),
    ]}
    onKeyDown={e => {
      if (e.key === 'ArrowLeft') {
        const element = document.querySelector(`#link_${item.id}_0`);
        (element as HTMLElement).focus();
      }
    }}
  >
    {reactHTMLParser(item.html)}
  </Box>
);

export default TechblogHtmlBlock;
